import { UISettings } from "./uiSettings";
import { ImmutableObject } from "../../../../shared";

export class UISettingsResponse extends ImmutableObject {

  protected readonly SETTINGS = "settings";

  get settings(): UISettings { return this.getInternalValue<UISettings>(this.SETTINGS); }
  setSettings(settings: UISettings): this { return this.setInternalValue(this.SETTINGS, settings); }
}